import { Component, OnInit, OnDestroy, ViewEncapsulation } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Subscription, BehaviorSubject, Observable } from "rxjs/Rx";
import { APIService } from "../../services/login/api";
import { Response } from "@angular/http";
import { ResetPasswordErrorResponseBody } from "../reset-password/reset-password.component";
import { ConfirmPasswordSetDialogComponent } from "./confirm-password-set-dialog/confirm-password-set-dialog.component";
import { MdDialogRef, MdDialogConfig, MdDialog } from "@angular/material";
import { ErrorDialogComponent } from "./error-dialog/error-dialog.component";
import { ForgotPasswordDialogComponent } from "../login/forgot-password-dialog/forgot-password-dialog.component";

interface ForgotPasswordForm {
  newPassword: string;
  newPasswordValidation: string;
}

@Component({
  selector: "forgot-password",
  template: require("./forgot-password.component.html"),
  styles: [require("./forgot-password.component.scss")],
  encapsulation: ViewEncapsulation.None
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  public token: string;
  public form: ForgotPasswordForm;
  public isTokenValid: boolean = false;

  public errorMessage: BehaviorSubject<string> = new BehaviorSubject("");

  private _tokenSubscription: Subscription;

  constructor(
    private _apiService: APIService,
    private activatedRoute: ActivatedRoute,
    private _router: Router,
    private _dialog: MdDialog
  ) {
    this.form = {
      newPassword: "",
      newPasswordValidation: ""
    };
  }

  public ngOnInit(): void {
    let self = this;
    // subscribe to router event to extract token
    this._tokenSubscription = this.activatedRoute.queryParams
      .flatMap((params: Params) => {
        this.token = params["token"];

        //check if token is valid token, if yes display form, if not redirect to login
        return self._apiService
          .validateToken(self.token)
          .flatMap((res: Response) => {
            if (res.status === 200) {
              self.isTokenValid = true;
            } else {
              self.isTokenValid = false;
              self._router.navigate(["/"]);
            }
            return Observable.of(undefined);
          })
          .catch(err => {
            //in case of invalid token server responses error
            this._dialog
              .open(ErrorDialogComponent)
              .afterClosed()
              .subscribe(() => {
                self.isTokenValid = false;
                this._dialog
                  .open(ForgotPasswordDialogComponent)
                  .afterClosed()
                  .subscribe(res => {
                    this._router.navigate(["/"]);
                  });
              });
            return Observable.of(undefined);
          });
      })
      .subscribe();
  }

  ngOnDestroy(): void {
    this._tokenSubscription.unsubscribe();
  }

  public onSubmit() {
    let self = this;
    this._apiService
      .setPasswordWithToken({
        token: this.token,
        newPass: this.form.newPassword
      })
      .subscribe(
        (res: Response) => {
          self.openApprovalDialog();
        },
        (err: Response) => {
          let st = err.status;
          switch (true) {
            case st >= 400 && st < 500:
              self.errorMessage.next(
                (<ResetPasswordErrorResponseBody>err.json()).errors.reduce(
                  (accumulator, value) => {
                    console.error("Token invalid", st);
                    return accumulator + "\n" + value;
                  },
                  ""
                )
              );
              break;
            default:
              self.errorMessage.next("Set password failed");
              break;
          }
        }
      );
  }

  private openApprovalDialog(): void {
    let self = this;
    let confirmPasswordSetDialogRef: MdDialogRef<
      ConfirmPasswordSetDialogComponent
    > = this._dialog.open(ConfirmPasswordSetDialogComponent, <MdDialogConfig>{
      disableClose: false
    });
    confirmPasswordSetDialogRef.afterClosed().subscribe(res => {
      self._router.navigate(["/"]);
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/forgot-password/forgot-password.component.ts